import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import SearchManager from './SearchManager';

const initialState = {
  main: null,
  modal: null
}

class RouterStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return initialState;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.ROUTER_NAVIGATE:
        return {
          ...state,
          main: action.url
        };

      case ActionTypes.ROUTER_MODAL_NAVIGATE:
        return {
          ...state,
          modal: action.url
        }

      case ActionTypes.MODAL_FULLSCREEN_CLOSE:
        return {
          ...state,
          modal: null
        }

      case ActionTypes.MODAL_FULLSCREEN_USER:
        return {
          ...state,
          modal: '/'
        }

      default:
        return state;
    }
  }
}

export default new RouterStore();
